<template>
  <div class="dispatch-field-container">
    <div class="dispatch-field-label-container scenario-script-label-container">
      <label for="scenario-script">
        Scenario Path
      </label>
      <md-button
        class="toggle-button md-dense"
        :disabled="!editor || !editor.can().chain().focus().toggleBold().run()"
        :class="{ 'is-active': editor && editor.isActive('bold') }"
        @click="editor.chain().focus().toggleBold().run()"
      >
        <md-icon>
          format_bold
        </md-icon>
      </md-button>
      <md-button
        class="toggle-button md-dense"
        :disabled="!editor || !editor.can().chain().focus().toggleItalic().run()"
        :class="{ 'is-active': editor && editor.isActive('italic') }"
        @click="editor.chain().focus().toggleItalic().run()"
      >
        <md-icon>
          format_italic
        </md-icon>
      </md-button>
      <md-button
        class="toggle-button md-dense"
        :disabled="!editor || !editor.can().chain().focus().toggleUnderline().run()"
        :class="{ 'is-active': editor && editor.isActive('underline') }"
        @click="editor.chain().focus().toggleUnderline().run()"
      >
        <md-icon>
          format_underlined
        </md-icon>
      </md-button>
      <md-button
        class="toggle-button md-dense"
        :disabled="!editor || !editor.can().chain().focus().toggleBulletList().run()"
        :class="{ 'is-active': editor && editor.isActive('bulletList') }"
        @click="editor.chain().focus().toggleBulletList().run()"
      >
        <md-icon>
          format_list_bulleted
        </md-icon>
      </md-button>
      <md-button
        class="toggle-button md-dense"
        :disabled="!editor || !editor.can().chain().focus().toggleOrderedList().run()"
        :class="{ 'is-active': editor && editor.isActive('orderedList') }"
        @click="editor.chain().focus().toggleOrderedList().run()"
      >
        <md-icon>
          format_list_numbered
        </md-icon>
      </md-button>
    </div>
    <editor-content class="editor" :editor="editor" />
  </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import { Indent } from './indent-extension';

export default {
  name: 'tiptap',
  components: {
    EditorContent,
  },
  props: {
    contents: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      editor: null,
    }
  },
  mounted() {
    this.editor = new Editor({
      content: this.contents,
      extensions: [
        StarterKit,
        Underline,
        Indent
      ],
    })
    this.editor.on('update', ({ editor }) => {
      this.emitUpdate(editor.getHTML());
    });
  },
  beforeDestroy() {
    this.editor.destroy()
  },
  methods: {
    emitUpdate(contents) {
      this.$emit('update', contents);
    }
  }
}
</script>

<style scoped>
.scenario-script-label-container {
  justify-content: flex-start ;
}

.editor >>> .tiptap.ProseMirror {
  margin: 0;
  border-radius: 5px;
  background-color: white;
  outline: none;
  padding: 6px 10px;
  border: 1px solid #c4c4c4;
  min-height: 100px;
  max-height: 300px;
  overflow: auto;
}

.editor >>> p {
  margin-block-start: 0;
  margin-block-end: 0;
}

.toggle-button {
  min-width: 32px;
  width: 32px;
  margin: 0 6px 6px 0;
}

.toggle-button:first-of-type {
  margin-left: 6px;
}

.toggle-button.is-active {
  background-color: #E0E0E0;
}
</style>

<style>
.ProseMirror:focus {
  outline: none;
}
</style>